webpackJsonp([57],{

/***/ "AjAC":
/***/ (function(module, exports, __webpack_require__) {

var SectionTextAside = (function () {
    function SectionTextAside() {
    }
    return SectionTextAside;
}());
angular.module('animatronApp.sectionTextAside', []).component('sectionTextAside', {
    bindings: {
        ltTitle: '<?',
        text: '<',
        relationList: '<?',
        imageUrl: '<?',
    },
    controller: SectionTextAside,
    templateUrl: __webpack_require__("S7Yw")
});


/***/ }),

/***/ "S7Yw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-text-aside_1180dbd2424cdd357ecc4a25e3e870bf.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/57-28dc41a6a889e793a2e2.min.js